import script from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=235a6a98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235a6a98"]])

export default __exports__